import * as cookie from "cookie";

/**
 * Set a cookie with secure settings
 *
 * @param {string} name - The name of the cookie
 * @param {string} value - The value to store in the cookie
 * @param {number} days - The number of days until the cookie expires (defaults to 1)
 */
export function setCookie(name: string, value: string, days: number = 1): void {
    const now = new Date();
    // We set the expiration date as of today plus the number of days that we received as argument.
    // We convert the days to miliseconds to do the math.
    const expires = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);

    const cookieString = cookie.serialize(name, value, {
        expires,
        path: "/",
        secure: true,
        sameSite: "strict",
    });
    document.cookie = cookieString;
}

/**
 * Get a cookie value by name
 */
export function getCookie(name: string): string | undefined {
    const cookies = cookie.parse(document.cookie);
    return cookies[name];
}

/**
 * Delete a cookie by setting it to expire in the past
 */
export function deleteCookie(name: string): void {
    const cookieString = cookie.serialize(name, "", {
        expires: new Date(0),
        path: "/",
        secure: true,
        sameSite: "strict",
    });
    document.cookie = cookieString;
}
